module.exports = __webpack_public_path__ + "static/media/buckeye-partners.e15267ad.svg";